export class AlertSound {
  private context: AudioContext | null = null;

  play(): void {
    try {
      this.context ??= new AudioContext();
      const now = this.context.currentTime;
      const gain = this.context.createGain();
      const oscillator = this.context.createOscillator();

      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(740, now);
      oscillator.frequency.setValueAtTime(880, now + 0.18);
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(0.18, now + 0.025);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.48);

      oscillator.connect(gain);
      gain.connect(this.context.destination);
      oscillator.start(now);
      oscillator.stop(now + 0.5);
    } catch {
      // Audio is an enhancement. Browser autoplay policy or missing Web Audio
      // support must never interrupt the timer.
    }
  }
}
